import React from 'react';
import { PCheckbox } from 'components/prime/PCheckbox/PCheckbox';
import { useObservableState } from 'observable-hooks';
import { useHeyYabbleCountStepBLoC } from '../../../../HeyYabbleCountStep.bloc';
import { HeyYabbleCountStepTableHeaderStyle as S } from './HeyYabbleCountStepTableHeader.style';
import { Text } from 'components/Text/Text';

export const HeyYabbleCountStepTableHeader: React.FC = () => {
  const { $isSelectedAll, $filteredColumn, handleChangeMainCheckbox } =
    useHeyYabbleCountStepBLoC();
  const isSelectedAll = useObservableState($isSelectedAll, false);
  const filteredColumn = useObservableState($filteredColumn, []);

  return (
    <S.Container>
      <S.CheckContainer>
        <PCheckbox
          checked={isSelectedAll}
          onChange={handleChangeMainCheckbox}
          disabled={!filteredColumn.length}
        />
      </S.CheckContainer>
      <S.ItemContainer>COLUMN NAME</S.ItemContainer>
      <S.WidthItem>CREDITS</S.WidthItem>
      <S.DropdownsItem>
        <Text>CODEFRAME</Text>
      </S.DropdownsItem>
    </S.Container>
  );
};
